<template>
  <div class="pos-cash-calculator">
    <div class="row">
      <div class="col-6 d-flex align-items-center mb-3">
        <div class="mr-2">Float Amount :</div>
        <div>
          <input v-model="float_amount_given" type="text" disabled />
        </div>
      </div>
      <div class="col-8 mb-3">
        <h5 class="font-weight-bold mb-3">
          {{ $t("total") }} {{ $t("amount") }} {{ $t("collected") }}
        </h5>
        <input v-model="scr_total_amount_collected" disabled type="text" />
      </div>
      <div class="col-12">
        <div class="row">
          <div class="col-8">
            <div class="row mx-0">
              <div class="w-100">
                <div class="d-flex flex-wrap">
                  <div
                    v-for="(cash, cashKey) in cashDenominations"
                    :key="cashKey"
                    v-on:click="onAdd(cash)"
                    class="btn-calc-container"
                  >
                    <button class="btn-calc">
                      {{ cash.denomination_value }}
                    </button>
                  </div>
                  <div class="btn-calc-container">
                    <button v-on:click="onClear()" class="btn-calc">C</button>
                  </div>
                  <!-- <div class="btn-calc-container">
                    <button class="btn-calc">2</button>
                  </div>
                  <div class="btn-calc-container">
                    <button class="btn-calc">3</button>
                  </div>-->
                </div>

                <!-- <div class="d-flex">
                  <div class="btn-calc-container">
                    <button class="btn-calc">4</button>
                  </div>
                  <div class="btn-calc-container">
                    <button class="btn-calc">5</button>
                  </div>
                  <div class="btn-calc-container">
                    <button class="btn-calc">6</button>
                  </div>
                </div>-->

                <!-- <div class="d-flex">
                  <div class="btn-calc-container">
                    <button class="btn-calc">7</button>
                  </div>
                  <div class="btn-calc-container">
                    <button class="btn-calc">8</button>
                  </div>
                  <div class="btn-calc-container">
                    <button class="btn-calc">9</button>
                  </div>
                </div>-->

                <!-- <div class="d-flex">
                  <div class="btn-calc-container">
                    <button class="btn-calc">0</button>
                  </div>
                  <div class="btn-calc-container">
                    <button class="btn-calc">.</button>
                  </div>
                  <div class="btn-calc-container">
                    <button class="btn-calc">C</button>
                  </div>
                </div>-->
              </div>
              <!-- <div class="w-50 pl-2">
                <div class="d-flex">
                  <div class="btn-auto-denomination-container">
                    <button class="btn-calc">5</button>
                  </div>
                  <div class="btn-auto-denomination-container">
                    <button class="btn-calc">10</button>
                  </div>
                </div>

                <div class="d-flex">
                  <div class="btn-auto-denomination-container">
                    <button class="btn-calc">20</button>
                  </div>
                  <div class="btn-auto-denomination-container">
                    <button class="btn-calc">50</button>
                  </div>
                </div>

                <div class="d-flex">
                  <div class="btn-auto-denomination-container">
                    <button class="btn-calc">100</button>
                  </div>
                  <div class="btn-auto-denomination-container">
                    <button class="btn-calc">200</button>
                  </div>
                </div>

                <div class="d-flex">
                  <div class="btn-auto-denomination-container">
                    <button class="btn-calc">500</button>
                  </div>

                  <div class="btn-auto-denomination-container">
                    <button class="btn-calc">1000</button>
                  </div>
                </div>
              </div>-->
            </div>
          </div>
          <!-- Cash input rows -->
          <div class="col-4 pl-0">
            <div class="d-flex flex-wrap">
              <div
                v-for="(cashValue, cashValueKey) in cashRow"
                :key="cashValueKey"
                v-on:click="onRemove(cashValue, cashValueKey)"
                class="btn-auto-denomination-container"
              >
                <button
                  class="btn-multiple d-flex justify-content-center align-items-center"
                >
                  <div class="counts-money">
                    {{ cashValue.denomination_value }} x {{ cashValue.count }}
                  </div>
                  <div class="close-btn">
                    <img
                      class="ml-1"
                      src="@/assets/img/icons/close-button.svg"
                      width="15"
                      height="15"
                    />
                  </div>
                </button>
              </div>
              <!-- <div class="btn-auto-denomination-container">
                <button class="btn-multiple">10 x 30</button>
              </div>-->
            </div>

            <!-- <div class="d-flex">
              <div class="btn-auto-denomination-container">
                <button class="btn-multiple">20 x 20</button>
              </div>
              <div class="btn-auto-denomination-container">
                <button class="btn-multiple">50 x 60</button>
              </div>
            </div>-->

            <!-- <div class="d-flex">
              <div class="btn-auto-denomination-container">
                <button class="btn-multiple">100 x 5</button>
              </div>
              <div class="btn-auto-denomination-container">
                <button class="btn-multiple">200 x 1</button>
              </div>
            </div>-->

            <!-- <div class="d-flex">
              <div class="btn-auto-denomination-container">
                <button class="btn-multiple">500 x 15</button>
              </div>

              <div class="btn-auto-denomination-container">
                <button class="btn-multiple">1000 x 1</button>
              </div>
            </div>-->
          </div>
          <!-- Cash input rows -->
        </div>
      </div>

      <!-- <div class="col-4 ml-auto pl-0">
        <div class="total-amount">
          <div>Total</div>
          <strong>{{currencyData.curr_code}} {{total}}</strong>
        </div>
      </div>-->
    </div>
    <nav>
      <!-- <router-link to="#" class="btn-outline-blue-lg bg-transparent text-blue mr-2">Back</router-link> -->
      <!-- <router-link to="pos-booking" class="btn-blue-lg ml-2">Next</router-link> -->
      <!-- <router-link to v-on:click.native="onClickNext()" class="btn-blue-lg ml-2">Next</router-link> -->
    </nav>
  </div>
</template>

<script>
import PosService from "@/services/PosService";
import MasterService from "@/services/MasterService";

export default {
  name: "CashInputCalculator",
  props: {
    nextRoute: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      // SAIF
      float_amount_given: 0,
      // SAIF
      scr_total_amount_collected: 0.0,
      float_id: null,
      cashDenominations: [],
      total: 0,
      cashRow: [],
      currencyData: [],

      currency: ""
    };
  },
  created() {},
  beforeMount() {
    this.getCashInput();
  },
  mounted() {
    this.getCashDenominations();

    this._GetGlobalOptions()
      .then(() => {
        this.getCurrencyCode();
      })
      .catch(error => {
        this.$toasted.show("Error while fetching global options " + error);
      });
  },
  methods: {
    getCashInput: function() {
      PosService.getCashInput()
        .then(result => {
          const { data } = result;
          if (data && data.status && data.Records.length > 0) {
            this.$store.dispatch("GET_SHIFT_DETAILS", data.Records[0]);
            this.float_amount_given = data.Records[0].float_amount_given;
            if (parseInt(this.float_amount_given) == 0) {
              this.$toasted.show("Your Float Amount is 0");
            }
          } else {
            // this.$toasted.show(data.message);
          }
        })
        .catch(err => {
          // this.$toasted.show(err);
        });
    },
    getCurrencyCode: function() {
      let payload = {
        tableName: "ms_currencies",
        curr_is_active: "Y",
        curr_id: this.secureStore.get("BRGLOPCUR")
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.currencyData = data.Records[0];
          } else {
            // Show Error Message:
            // console.log("data.message :", data.message);
          }
        })
        .catch(error => {
          // Catch Error:
          // console.log("Catch Error on getActiveScreenByCinemaId :", error);
        });
    },
    getCashDenominations: function() {
      let loader = this.$loading.show();
      PosService.getCashDenominations()
        .then(result => {
          const { data } = result;
          loader.hide();

          if (data.status) {
            this.cashDenominations = data.Records;
            this.cashDenominations.map(x => {
              x["count"] = 0;
              x["value"] = parseInt(x.denomination_value);
              return x;
            });
          } else {
            // this.$toasted.show(data.message);
          }
        })
        .catch(err => {
          // this.$toasted.show(err);
        });
    },
    onAdd: function(data) {
      let index = this.cashRow.findIndex(
        x => x.denomination_value == data.denomination_value
      );
      if (index > -1) {
        data.count++;
        this.cashRow[index].value =
          parseFloat(data.denomination_value) * data.count;
      } else {
        data.count++;
        data.value = parseFloat(data.denomination_value);
        this.cashRow.push(data);
      }
      this.$store.dispatch("SET_TOTAL_CASH_COLLECTED", 0);
      let tempVal = 0;
      this.scr_total_amount_collected = 0;
      this.cashRow.map(x => {
        tempVal += parseFloat(x.value);
        this.scr_total_amount_collected += +parseFloat(x.value).toFixed(1);
        this.$store.dispatch("SET_TOTAL_CASH_COLLECTED", tempVal);
      });
      this.$store.dispatch("SET_CASH_DENOMINATION", this.cashRow);
    },
    onRemove: function(data, index) {
      this.scr_total_amount_collected -= data.value;
      this.$store.dispatch(
        "SET_TOTAL_CASH_COLLECTED",
        this.scr_total_amount_collected
      );
      this.cashRow = this.cashRow.map((x, key) => {
        if (x.denomination_value == data.denomination_value) {
          x.count = 0;
          x.value = parseFloat(x.denomination_value);
        }
        return x;
      });
      this.cashRow.splice(index, 1);
      this.$store.dispatch("SET_CASH_DENOMINATION", this.cashRow);
    },
    onClear: function() {
      this.scr_total_amount_collected = 0;
      this.$store.dispatch("SET_TOTAL_CASH_COLLECTED", 0);
      this.cashRow.map((x, key) => {
        x.count = 0;
        x.value = parseInt(x.denomination_value);
        return x;
      });
      this.cashRow = [];
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Partials/posShiftCloseCalculator.vue